import http from "../http-common"

class ConvergenceFooterService {
    getAllconvergenceFooter(pathName: string) {
        return http.get(`/convergence-footer?path=${pathName}`)
    }
}


export default new ConvergenceFooterService();